import type { CSSProperties } from 'react';

/**
 * HexFrameView — TCP/gRPC 콘솔 공용 hex 뷰 (§Δ.3)
 * hex 문자열을 바이트 쌍(2자) 단위로 그룹핑해 가독성 있게 렌더.
 * prefixHex 가 주어지면(TCP 4B length prefix) 별색으로 구분 표시.
 */
export function HexFrameView({
  label,
  hex,
  prefixHex,
}: {
  label: string;
  hex: string;
  prefixHex?: string;
}) {
  const bytePairs = hex.match(/.{1,2}/g) ?? [];
  const prefixByteCount = prefixHex ? (prefixHex.match(/.{1,2}/g) ?? []).length : 0;

  return (
    <div>
      <p style={labelStyle}>{label}</p>
      <div style={hexBoxStyle}>
        {bytePairs.length === 0 ? (
          <span style={{ color: 'var(--color-text-muted)' }}>—</span>
        ) : (
          bytePairs.map((pair, i) => (
            <span
              key={i}
              style={{
                color: i < prefixByteCount ? 'var(--color-brand-primary)' : 'var(--color-text-primary)',
                fontWeight: i < prefixByteCount ? 700 : 400,
              }}
            >
              {pair}
            </span>
          ))
        )}
      </div>
    </div>
  );
}

const labelStyle: CSSProperties = {
  fontSize: 'var(--font-size-xs)',
  color: 'var(--color-text-secondary)',
  marginBottom: 'var(--spacing-1)',
};

const hexBoxStyle: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'var(--spacing-1)',
  padding: 'var(--spacing-3)',
  background: 'var(--color-surface-muted)',
  border: '1px solid var(--color-surface-border)',
  borderRadius: 'var(--radius-sm)',
  fontFamily: 'var(--font-family-mono)',
  fontSize: 'var(--font-size-xs)',
  wordBreak: 'break-all',
};
